import * as React from "react";
const tv = (props) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 20 20"
    {...props}
  >
    <defs>
      <style>
        {
          "\n      .st0 {\n        fill: #c1272d;\n      }\n\n      .st1 {\n        fill: lime;\n      }\n    "
        }
      </style>
    </defs>
    <path className="st1" d="M33.9,65" />
    <path className="st1" d="M34.8,64.5" />
    <path d="M18.3,14.5c0-2.3,0-6.3,0-8h0c0-1.3-1.4-1.5-2.3-1.5-.9,0-2.1,0-2.9,0-.1,0,0-.1.1-.3.4-.6,1.2-1.1,1.1-1.8,0-.7-1-1.1-1.5-.7-.5.4-1.5,1.7-2.1,2.2-.2.3-.3.4-.4.4-.6-.5-1.7-1.9-2.3-2.5-.4-.4-1.2-.5-1.5,0-.8,1,.8,1.9,1.1,2.6-1,0-2.8,0-3.7,0-1.8,0-1.6,1.4-1.6,2.8,0,2.6,0,7.4,0,7.9,0,.4.2.9.6,1.1.4.3.9.2,1.2.3,0,0,0,.2.1.3,0,0,0,0,0,0v.6h1.6l.6-.8c0,0,.2-.1.4-.1,1.8,0,5.2,0,6.7,0,.5,0,.5,0,.7.2,0,0,0,.1.1.2,0,0,0,0,0,0l.4.5h1.6v-.6c0-.2.1-.3.3-.3.5,0,1.1-.1,1.4-.6.4-.7.2-1.2.2-2ZM13.8,14.9c-1.5.2-3.1.2-4.7.2-1.4,0-3,0-4.4-.2-.4-.2-.4-.7-.5-1.1,0-2-.2-4.3.1-6.2.2-.4.7-.4,1.1-.4,2-.1,3.8,0,5.8-.1,1,0,2.2,0,3.1.4.2.1.2.4.2.6,0,.7,0,1.4,0,2,0,.8.1,2.1,0,2.9h0c-.2,1,0,2-1,2ZM16.4,12c-.3,0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5ZM16.4,10c-.3,0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5Z" />
    <image
      width={16}
      height={16}
      transform="translate(-93.5 -6.7) scale(.2)"
      xlinkHref="tv-1.png"
    />
    <path
      className="st0"
      d="M-92.1,36.3c0-4.6,0-12.4,0-15.6v-.3c-.2-2.3-2.7-2.7-4.5-2.6-1.7-.1-4,.2-5.6,0-.3,0-.1-.2.2-.6.9-1.1,2.4-2.2,2.2-3.6-.1-1.4-1.9-2.1-3-1.3-1,.8-3,3.3-4,4.3-.5.5-.7.8-.8.8-1.2-1-3.3-3.7-4.5-4.8-.8-.8-2.3-.9-3,.1-1.6,2,1.6,3.7,2.2,5.1-2,0-5.4,0-7.3,0-3.5,0-3.2,2.8-3.1,5.5,0,5,0,14.5,0,15.5,0,.7.4,1.7,1.2,2.1.7.5,1.7.3,2.4.6.1.1.2.3.2.5,0,0,0,0,0,0v1.1h3.1l1.1-1.6c.2-.2.4-.3.8-.2,3.5,0,10.1,0,13.1,0,.9,0,1.1-.2,1.4.3,0,0,.2.2.3.4,0,0,0,0,0,0l.7,1h3.1v-1.1c0-.3.3-.5.6-.5.9,0,2.1-.3,2.7-1.2.8-1.4.4-2.3.5-3.9ZM-100.9,37.1c-3,.5-6,.4-9.1.4-2.8,0-5.9,0-8.6-.5-.9-.3-.8-1.3-.9-2.2-.1-4-.4-8.4.3-12.2.3-.8,1.3-.7,2.1-.9,3.9-.3,7.4-.2,11.4-.3,2,.2,4.3,0,6.1.8.3.3.4.8.4,1.1.2,1.3,0,2.7.1,4,0,1.6.2,4.1,0,5.8v.3c-.3,1.7.2,3.7-1.9,3.7ZM-95.9,31.6c-.6,0-1-.5-1-1s.5-1,1-1,1,.5,1,1-.5,1-1,1ZM-95.9,27.6c-.6,0-1-.5-1-1s.5-1,1-1,1,.5,1,1-.5,1-1,1Z"
    />
  </svg>
);
export default tv;
